import {action, makeAutoObservable, observable, runInAction} from "mobx";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import {type IJSONProvider} from "data/providers/json/json.provider";
import {TournamentStatus} from "data/enums";
import {includes} from "lodash";

export interface ITournament {
	id: number;
	feedId: string;
	roundId: number;
	venueId: number;
	homeSquadId: number;
	awaySquadId: number;
	startDate: string;
	status: TournamentStatus;
	homeSquadScore: number | null;
	awaySquadScore: number | null;
}

export interface ITournamentsStore {
	get tournaments(): ITournament[];
	get playOffTournaments(): ITournament[];
	get availablePlayoffTournaments(): ITournament[];

	matchesByRoundId: (roundId: number) => ITournament[];
	fetchTournaments(): Promise<void>;
}

@injectable()
export class TournamentsStore implements ITournamentsStore {
	@observable private _list: ITournament[] = [];

	get tournaments() {
		return this._list;
	}

	get playOffTournaments() {
		return this._list.filter((tournament) => tournament.roundId > 10);
	}

	get availablePlayoffTournaments() {
		return this.playOffTournaments.filter((tournament) =>
			includes([TournamentStatus.Playing, TournamentStatus.Scheduled], tournament.status)
		);
	}

	constructor(@inject(Bindings.JSONProvider) private _jSONProvider: IJSONProvider) {
		makeAutoObservable(this);
	}

	matchesByRoundId = (roundId: number) => {
		return this._list.filter((match) => match.roundId === roundId);
	};

	@action
	async fetchTournaments() {
		const {data} = await this._jSONProvider.tournaments();

		runInAction(() => {
			this._list = data.items;
		});
	}
}
